import React, { useMemo } from 'react'
import { MatchupBoxCon, MatchupAction, TeamCon, MatchupTeam } from './styles'
import {
  logEvent,
  getActionText,
  getEventActionLink,
  getBroadcastImg,
  getGameTimeLocal,
} from '../../../Utils'
import { Final } from './Final'
import { EventGQL, TeamGQL } from '../../../Api'
import { getTeamIc } from '../../../Utils'
import { createUrl } from '../../../Routing/urls'
import { Img } from '../../Image/Img'
import { ANALYTICS_TAGS } from '../../../Constant'
import { Lk } from '../../Links/Lk'

type MatchupProps = {
  event: EventGQL
  champion?: TeamGQL | null
}

export const MatchupBox: React.FC<React.PropsWithChildren<MatchupProps>> = ({
  event,
  champion,
}) => {
  const liveGame = event?.eventStatus === 1 ? true : false

  const homeTeam = useMemo(() => event?.homeTeam, [event])
  const awayTeam = useMemo(() => event?.awayTeam, [event])

  const log = (ev: string) => {
    logEvent(ev, {
      eventId: event.slugname,
      event_status: event.eventStatus,
    })
  }

  return (
    <MatchupBoxCon isLive={liveGame}>
      <div className="teamRow">
        <TeamCon champion={!!champion}>
          {homeTeam && (
            <Lk
            classNameObj="lnk"
            role="link"
              link={createUrl('teams', { id: homeTeam.fullName })}
              alt={`${homeTeam.fullName} roster`}
            >
              <MatchupTeam>
                <Img
                  src={getTeamIc(homeTeam.fullName)}
                  alt={`${homeTeam.fullName} logo`}
                />
                {homeTeam?.seed && homeTeam.seed > 0 && (
                  <span className="seed">{homeTeam.seed || ''}</span>
                )}
                <span className="name">{homeTeam.location ?? homeTeam.fullName}</span>
              </MatchupTeam>
            </Lk>
          )}
          {event.eventStatus >= 1 && <span className="score">{event.homeScore}</span>}
        </TeamCon>
      </div>
      <div className="teamRow">
        <TeamCon champion={!!champion}>
          {awayTeam && (
            <Lk
              classNameObj="lnk"
              role="link"
              link={createUrl('teams', { id: awayTeam.fullName })}
              alt={`${awayTeam.fullName} roster`}
            >
              <MatchupTeam>
                <Img
                  src={getTeamIc(awayTeam.fullName)}
                  alt={`${awayTeam.fullName} logo`}
                />
                {awayTeam?.seed && awayTeam?.seed > 0 && (
                  <span className="seed">{awayTeam.seed || ''}</span>
                )}
                <span className="name">{awayTeam.location ?? awayTeam.fullName}</span>
              </MatchupTeam>
            </Lk>
          )}
          {event.eventStatus >= 1 && <span className="score">{event.visitorScore}</span>}
        </TeamCon>
      </div>
      <div className="gameInfo">
        {event && event?.eventStatus <= 1 ? (
          <>
            <p>{getGameTimeLocal(event.startTime)}</p>
            <div className="broadcastCon">
              {getBroadcastImg(event.broadcaster).map((b, idx) => (
                <Img key={b} src={b} alt={event.broadcaster[idx]} />
              ))}
            </div>
          </>
        ) : (
          <Final event={event} />
        )}
      </div>
      {event && (
        <MatchupAction
          onClick={() => log(ANALYTICS_TAGS.bracket_action_click)}
          live={liveGame}
        >
          <Lk link={getEventActionLink(event)} alt={getActionText(event.eventStatus)}>
            {getActionText(event.eventStatus)}
          </Lk>
        </MatchupAction>
      )}
    </MatchupBoxCon>
  )
}
